export const lambdaProfileToContentProfile = (profile) => {
    return {
        ...profile,
        avatars: profile.avatars.map(avatar => ({
            ...avatar,
            avatar: {
                ...avatar.avatar,
                snapshots: Object.entries(avatar.avatar.snapshots)
                    .map(([key, value]) => ({
                    [key]: value.replace(/.*\//, '')
                }))
                    .reduce((acc, curr) => {
                    return { ...acc, ...curr };
                }, {})
            }
        }))
    };
};
export const getHashesByKeyMap = (avatar) => {
    const hashesByKey = new Map();
    Object.entries(avatar.avatar.snapshots).forEach(([key, value]) => {
        hashesByKey.set(`${key}.png`, value);
    });
    return hashesByKey;
};
//# sourceMappingURL=utils.js.map